module.exports = __webpack_public_path__ + "img/P53-zh.e8a3fd2a.png";